import React, { SyntheticEvent, useRef, useState } from 'react'
import { ReactComponent as IcoDM } from 'assets/icons/Logo.svg'
import style from './Auth.module.css'
import axiosClient from 'axios-client'

const Forgot: React.FC = () => {
  const emailRef = useRef<HTMLInputElement>(null)
  const [message, setMessage] = useState<string>()

  const [loading, setLoading] = useState(false)

  const onSubmit = (ev: SyntheticEvent) => {
    ev.preventDefault()

    setLoading(true)
    axiosClient
      .post('/forgotpw', { email: emailRef.current?.value })
      .then(() => {
        
        setMessage('Mail was sent!')
      }).finally(()=>setLoading(false));
  }

  return (
    <form className={`${style.form}`}>
      <IcoDM className={`${style.logo}`} />
      <input
        type='email'
        placeholder='Email'
        className={`${style.input}`}
        ref={emailRef}
        required
      />
      <div
        className={`${style.row} ${style.message}`}
        style={{ display: message === '' ? 'none' : '' }}
      >
        {message}
      </div>
      <input
        type='submit'
        value={loading ? 'Sending Email...' : 'Submit'}
        className={`${style.submit}`}
        onClick={onSubmit}
        disabled={loading}
      />
    </form>
  )
};

export default Forgot;
